export default __webpack_public_path__ + "static/media/press_room_thumb_modal9.bf0045e5.png";